import { render, staticRenderFns } from "./fundsetting.vue?vue&type=template&id=5a95544e&"
import script from "./fundsetting.vue?vue&type=script&lang=js&"
export * from "./fundsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports